<!-- https://www.figma.com/file/JGnLzMLGla9gSsvnW00NUY/Burning-Design-System-%F0%9F%94%A5?node-id=743%3A67432&t=rk5MTxanM2aanWJT-0 -->
<template>
  <div class="reaction-menu-wrapper">
    <div class="reaction-menu">
      <ReactionButton
        v-for="({ type, count }, index) of reactions"
        :key="index"
        class="reaction-menu__item-wrapper"
        :button-reaction="type"
        :is-current="isCurrent(type)"
        :count="count"
        :show-zero-count="showCount"
        :button-type="'menu'"
        @reaction-button-click="$emit('reaction-click', type)"
        @reaction-button-hold="$emit('reaction-click', type)"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ReactionButton from './ReactionButton.vue';
  import type { AvailableReaction, IReactions } from '~/types/components/Reactions';

  export default defineNuxtComponent({
    name: 'ReactionMenu',

    components: { ReactionButton },

    props: {
      reactions: {
        type: Array as PropType<IReactions[]>,
        required: true,
      },

      currentReaction: {
        type: String as PropType<AvailableReaction>,
        default: 'default',
      },
    },

    computed: {
      showCount(): boolean {
        return this.reactions.some((reaction) => !!reaction.count);
      },
    },

    methods: {
      isCurrent(type: AvailableReaction): boolean {
        return type === this.currentReaction;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .reaction-menu {
    background: #ffffff;
    border: 4px solid #000000;
    box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    overflow: hidden;
    display: flex;
    align-items: center;

    &-wrapper {
      position: absolute;
      z-index: 1;
      left: -$spacing-3;
      bottom: calc(100% + 4px);

      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 8px;
        left: 0;
        top: 100%;
        background: transparent;
      }
    }

    &__item {
      &-wrapper {
        padding: $spacing-2;
        gap: 2px;
        color: $text-color--4;
        cursor: pointer;
        border-radius: 0;

        @include tinyText;
        font-weight: 400;
        display: flex;
        align-items: center;
        flex-direction: column;

        &:last-child {
          padding-right: 10px;
        }

        &:first-child {
          padding-left: 10px;
        }

        @include hover {
          background: $hover-color--5;
          color: $text-color--1;
        }

        &.current {
          color: $text-color--1;
        }
      }
    }
  }
</style>
